export const appReference = 2;